<template>
<div :ref="LoadingObj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">举报记录</span>
        <div class="TTL-BTN-LIST">
            <wcbutton :option="{title:'返回举报记录',type:'del'}" class="left15" @finish="(val)=> {$parent.JUMPVIEW({name:'EsFrozen'})}" />
        </div>
    </div>

    <div class="ttl-goods-table top40">
        <table border="1" style="border-collapse: collapse;border-spacing: 0;">
            <tr>
                <th width="20%" align="center">举报商品</th>
                <th width="20%" align="center">商品名称</th>
                <th width="20%" align="center">举报人</th>
                <th width="20%" align="center">举报原因</th>
                <th width="20%" align="center">处理结果</th>
            </tr>
            <tr>
                <td align="center"><wcimage :option="{size:'middle'}" :value="frozeninfo.goodsthumb" /></td>
                <td align="center">{{frozeninfo.goodsname}}</td>
                <td align="center">{{frozeninfo.reportmembername}}</td>
                <td align="center">{{frozeninfo.reason}}</td>
                <td align="center">
                    <div v-if="frozeninfo.is_handle==0">未处理</div>
                    <div v-if="frozeninfo.is_handle==1">冻结商品</div>
                    <div v-if="frozeninfo.is_handle==2">冻结会员</div>
                    <div v-if="frozeninfo.is_handle==3">忽略</div>
                </td>
            </tr>
             
        </table>
    </div>
            
</div>


</template>

<script>
import INTERFACE_MODEL_GOODS from '@/Interface/Es/Goods/Goods';

export default {
    components:{},
    data() {
        return {
            LoadingObj:'FrozenDetail',  //loading对象   
            frozeninfo:{}, //商品信息 
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.GetFrozenDetail(data.param.id);
            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetFrozenDetail(data.param.id);
            } 
        },


        /** 获取商品信息详情 **/
        GetFrozenDetail(id) {
            var obj=this.$refs[this.LoadingObj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_GOODS.GET_FROZEN_LOG_DETAIL({id:id}).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.frozeninfo=res.data;
            });
        },


    },
}
</script>
<style scoped>
.ttl-goods {padding:20px 15px 50px 15px;width:calc(100% - 30px);}
.ttl-member-info {display: inline-flex;align-items: center;width:100%;font-size:0;}
.ttl-member-info i {font-style: normal;color:#666eeb;font-size:13px;cursor: pointer;}
.ttl-member-info .el-image {width:80px;height:80px;border-radius: 50%;box-shadow: 0 0 10px #dddddd;}
.ttl-member-info span {display: inline-flex;align-items: center;font-size:13px;color:#666666;}
.ttl-frozen {box-shadow: 0 !important;width:20px !important;height: 20px !important;}
.ttl-member-status {display: inline-flex;align-items: center;}

.ttl-goods-table {display:inline-block;width:100%;}
.ttl-goods-table table {width:100%;border-color: #EBEDF0;padding:0;}
.ttl-goods-table table th {background-color: #EBEDF0;}
.ttl-goods-table table th,.ttl-goods-table table td {padding:20px;font-size:13px;color:#333333;font-weight: normal;}
.numbers {color:#666eeb;cursor: pointer;}
</style>